module.exports = __webpack_public_path__ + "img/ic_bed_sandh_3.d5dabdd3.png";